import {createSlice} from "@reduxjs/toolkit";

export const tendanceSlice = createSlice({
    name:'tendance',
    initialState:{
        value:7
    },
    reducers:{
        getTrending:(state,action)=>{
            state.value = action.payload;
        }
    }
})

export const {getTrending} = tendanceSlice.actions
export default tendanceSlice.reducer
